import { useAuth } from "react-oidc-context";
import { Box, Typography, styled, alpha} from '@mui/material'
import { BLUE_LIGHT, BLUE_LIGHT_RGB_BORDER, BLUE_MAIN, GREEN_LOGO, WHITE } from "../../theme/colors";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { AssociationItemProps } from "./interfaces";

const LinkBase = styled('a')(({ theme }) => ({
    textDecoration: 'none', 
    color:'inherit',
    '&:hover': {
        letterSpacing:'0.4px'
    },
}));

const AssociationsItem = (props:AssociationItemProps) => {
    const {t} = useTranslationContext();
    return (
        <Box sx={{
            width:'100%',
            //border:'1px solid '+ BLUE_LIGHT_RGB_BORDER,
            minHeight:'120px',
            dispaly:'flex',
            flexDirection:'column',
            //margin:'10px 0',
            //borderRadius:'5px'
        }}>
            <Box sx={{
                display:'flex',
                width:'100%',
                height:'30px',
                justifyContent:'left',
                fontSize:'1.2em',
                fontWeight:600,
                color: GREEN_LOGO
            }}>
                {props.name}
            </Box>

            <Box sx={{
                    height: '100px', 
                    overflow: 'hidden',
                    paddingTop: 1
                }}>
                <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {props.cap ? props.cap : ''} {props.city}, {props.province} - {props.nation}
                </Typography>

                {props.mail && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    <strong>{t("E-mail: ")}</strong> {props.mail ? <LinkBase href={`mailto:${props.mail}`} target="_blank">{props.mail}</LinkBase> : ''}
                </Typography>}

                {props.phone && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                }}>
                    <strong>{t("Telefono: ")}</strong> {props.phone}
                </Typography>}

                {props.website && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                }}>
                    <strong>{t("Sito internet: ")}</strong> {props.website ? <LinkBase href={props.website} target="_blank">{props.website}</LinkBase> : ''}
                </Typography>}
                
                {props.subcriptionUrl && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                }}>
                    <strong>{t("Iscriviti: ")}</strong> {props.subcriptionUrl ? <LinkBase href={props.subcriptionUrl} target="_blank">{props.subcriptionUrl}</LinkBase> : ''}
                </Typography>}
                
                {props.socialLink && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                }}>
                    <strong>{t("Social: ")}</strong> {props.socialLink ? <LinkBase href={props.socialLink} target="_blank">{props.socialLink}</LinkBase> : ''}
                </Typography>}
            </Box>
            
        </Box>
    );
}

export default AssociationsItem;